@if (avatar()) {
  <img
    referrerpolicy="no-referrer"
    data-testid="avatar-image"
    [ngClass]="size()"
    [class.round]="round()"
    [ngSrc]="avatar()!"
    [height]="pixels()"
    [width]="pixels()"
    [alt]="alt()"
    [disableOptimizedSrcset]="true"
  />
} @else {
  <span
    data-testid="avatar-fallback"
    role="presentation"
    class="fallback fallback--{{ size() }}"
    [class.round]="round()"
  >
    <span>{{ alt() }}</span>
  </span>
}

@if (rosette()) {
  <span class="rosette rosette--{{ size() }}">{{ rosette() }}</span>
}
